
import axios from 'axios'

export default {
    state: {
        lead: {
            api_token: '',
            dealer_id: '',
            date: '',
            hour: '',
            first_name: '',
            last_name: '',
            email: null,
            phone_number: null,
            registration_number: '',
            description: '',
            door_to_door: 0,
            replacement_car: '0',
            model_id: null,
            brand_id: 13,//BMW
            // additional
            brand_val: null,
            comment_val: null,
            services_val: [],
            services_name: [],
            operation_group_ids: [],
            visit_date_val: null,
            visit_hour_val: 1,
            additional_options_val: [],
            subAdditionalOptions: [],
            postcode_val: null,
            city_val: null,
            address_val: null,
            country_val: null,
            phone_number_additional_val: null,
            accept1_val: null,
            mileage: null,
            vin: null,
            model_id: null,
            replacement_car_val: null,
            // term preferences
            date_from: null,
            date_to: null,
            date_hour_from: null,
            hour_from: null,
            hour_to: null,
            term_key: null,
            service_time: 0,//szacowany czas naprawy
            visit_hour_name: '', // nazwa pory dnia
            // replacement car
            replacement_car_id: null,
            // advisor
            advisor_id: null,
            repair: null,
            mechanic_id: null,
            mechanic_hour: null,
            days: 16
        },
        leadToDescription: {
            brand_val: "Marka",
            model_id: "Model",
            vin: "Vin",
            mileage: "Przebieg",
            postcode_val: "Kod pocztowy",
            city_val: "Miasto",
            address_val: "Adres",
            country_val: "Kraj",
            phone_number_additional_val: "Dodatkowy numer telefonu",
            accept1_val: "Zgoda RODO",
            additional_options_val: "Dodatkowe opcje",
            comment_val: "Komentarz",
            visit_date_val: "Szukał terminu od",
            visit_hour_name: "Pora dnia",
            service_time: "Szacowany czas naprawy",
            replacement_car_val: "Samochód zastępczy",
            subAdditionalOptions: "Dodatkowe opcje z dodatkowych opcji"
        },
        validation: {
            brand: true,
            service: false,
            visit: false,
            client: false,
            car: false
        },
        leadResponse: false
    },
    mutations: {
        setLead(state, payload) {
            let lead = Object.assign({}, state.lead, payload);
            state.lead = {};
            state.lead = lead;
         },
        setLeadResponse(state, payload) { state.leadResponse = payload },
        setValidation(state, payload) { state.validation = payload }
    },
    getters: {
        getLead: state => state.lead,
        getValidation: state => state.validation,
        getLeadResponse: state => state.leadResponse
    },
    actions: {
        clearLeadResponse({ commit }) {
            commit('setLeadResponse', false);
        },
        async sendLead({ commit, state, rootState }) {
            const ready = await this._vm.$recaptchaLoaded();
            if (ready) {

                const token = await this._vm.$recaptcha('login');

                if (token) {

                    // szacowany czas naprawy
                    state.lead.service_time = state.lead.services_val.length;

                    let description = Object.keys(state.leadToDescription).map(k => {

                        let value = [null, false].includes(state.lead[k]) ? '-' : state.lead[k];

                        return state.leadToDescription[k] + ": " + value + "/\n";
                    });

                    description += "/\n Wybrane usługi serwisowe: " + state.lead.services_name.join(', ')

                    state.lead.description += description;

                    let leadWithNonEmptyValues = {};
                    Object.keys(state.lead).forEach(key => {
                        if (state.lead[key] !== null && state.lead[key] !== '') {
                            leadWithNonEmptyValues[key] = state.lead[key];
                        }
                    });


                    var formData = new FormData()
                    Object.keys(leadWithNonEmptyValues).forEach((key) => {
                        formData.append(key, leadWithNonEmptyValues[key])
                    });

                    formData.append('recaptcha_token', token);

                    var xmlHttp = new XMLHttpRequest()
                    xmlHttp.onreadystatechange = function () {
                        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                            let response = JSON.parse(xmlHttp.responseText);
                            commit('setLeadResponse', response);
                            dataLayer.push({ 'event': 'form_submit' });
                        }
                    }
                    xmlHttp.open('post', 'https://inchcape.ebusters.com.pl/send')
                    xmlHttp.send(formData)
                }

            }

        }
    },
    namespaced: true
}